"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionContent = exports.Accordion = void 0;
const react_1 = __importStar(require("react"));
const Accordion_styled_1 = require("./Accordion.styled");
const ChevronUp_1 = require("../icons/ChevronUp/ChevronUp");
const useSize_1 = require("../../hooks/useSize");
const Accordion = ({ title, withBorder = false, children, defaultOpen = false }) => {
    const [isVisible, setVisibility] = (0, react_1.useState)(defaultOpen);
    const [initialContentHeight, setInitialContentHeight] = (0, react_1.useState)(0);
    const target = (0, react_1.useRef)(null);
    const size = (0, useSize_1.useSize)(target);
    (0, react_1.useEffect)(() => {
        if (size && size.height) {
            setInitialContentHeight(size.height);
        }
    }, [initialContentHeight, size]);
    return (react_1.default.createElement(Accordion_styled_1.AccordionWrapperStyled, { withBorder: withBorder },
        react_1.default.createElement(Accordion_styled_1.TopStyled, { onClick: () => setVisibility(!isVisible) },
            react_1.default.createElement("div", null, title),
            react_1.default.createElement(Accordion_styled_1.ToggleVisibilityWrapperStyled, { isVisible: isVisible },
                react_1.default.createElement(ChevronUp_1.ChevronUpIcon, null))),
        react_1.default.createElement(exports.AccordionContent, { isVisible: isVisible }, children)));
};
exports.Accordion = Accordion;
const AccordionContent = ({ isVisible, children }) => {
    const [initialContentHeight, setInitialContentHeight] = (0, react_1.useState)(0);
    const target = (0, react_1.useRef)(null);
    const size = (0, useSize_1.useSize)(target);
    (0, react_1.useEffect)(() => {
        if (size && size.height) {
            setInitialContentHeight(size.height);
        }
    }, [initialContentHeight, size]);
    return (react_1.default.createElement(Accordion_styled_1.ExpansionPanelStyled, { isVisible: isVisible, height: initialContentHeight },
        react_1.default.createElement("div", { ref: target }, children)));
};
exports.AccordionContent = AccordionContent;
